<template>
  <div class="units">
    <div class="row text-center">
      <div class="btn-group filter-group">
        <button
          @click="setFilteredUnits('All')"
          type="button"
          class="btn"
          :class="[
            {
              'btn-action-selected-yamaha':
                selectedFilter == 'All' && brand == 'yamaha',
            },
            {
              'btn-action-selected-husky':
                selectedFilter == 'All' && brand == 'husky',
            },
            {
              'btn-action-selected-ktm':
                selectedFilter == 'All' && brand == 'ktm',
            },
            `btn-action-outline-${brand}`,
          ]"
        >
          {{ $t('message.allUnits') }}
        </button>
        <button
          v-if="filters.includes('Frame')"
          @click="setFilteredUnits('Frame')"
          type="button"
          class="btn"
          :class="[
            {
              'btn-action-selected-yamaha':
                selectedFilter == 'Frame' && brand == 'yamaha',
            },
            {
              'btn-action-selected-husky':
                selectedFilter == 'Frame' && brand == 'husky',
            },
            {
              'btn-action-selected-ktm':
                selectedFilter == 'Frame' && brand == 'ktm',
            },
            `btn-action-outline-${brand}`,
          ]"
        >
          {{ $t('message.frame') }}
        </button>
        <button
          v-if="filters.includes('Engine')"
          @click="setFilteredUnits('Engine')"
          type="button"
          class="btn"
          :class="[
            {
              'btn-action-selected-yamaha':
                selectedFilter == 'Engine' && brand == 'yamaha',
            },
            {
              'btn-action-selected-husky':
                selectedFilter == 'Engine' && brand == 'husky',
            },
            {
              'btn-action-selected-ktm':
                selectedFilter == 'Engine' && brand == 'ktm',
            },
            `btn-action-outline-${brand}`,
          ]"
        >
          {{ $t('message.engine') }}
        </button>
        <button
          v-if="filters.includes('Other')"
          @click="setFilteredUnits('Other')"
          type="button"
          class="btn btn-action-outline"
          :class="[
            {
              'btn-action-selected-yamaha':
                selectedFilter == 'Other' && brand == 'yamaha',
            },
            {
              'btn-action-selected-husky':
                selectedFilter == 'Other' && brand == 'husky',
            },
            {
              'btn-action-selected-ktm':
                selectedFilter == 'Other' && brand == 'ktm',
            },
            `btn-action-outline-${brand}`,
          ]"
        >
          {{ $t('message.otherUnits') }}
        </button>
      </div>
    </div>
    <div class="row">
      <div
        v-for="(unit, index) in filteredUnits"
        :key="index"
        @click="
          selectUnit({
            selectedUnit: {
              name: unit.name,
              id: unit.id,
              illustUrl: unit.illustUrl,
            },
          })
        "
        class="search_schema_details col-sm-3 col-xs-4"
        v-scroll-to="'#app'"
      >
        <div
          class="panel panel-default panel-unit"
          :class="`${brand}-border-hover`"
        >
          <div class="panel-body">
            <img
              v-if="brand === 'kawasaki'"
              :src="unit.iconUrl"
              onerror="this.onerror=null;this.src='https://i.imgur.com/lQfiJGA.gif';"
              class="img-responsive img-unit"
              alt="Unit"
            />
            <zoom-on-hover
              v-else
              :img-normal="unit.iconUrl"
              :img-zoom="unit.illustUrl"
              onerror="this.onerror=null;this.src='https://i.imgur.com/lQfiJGA.gif';"
              class="img-responsive img-unit"
              alt="Unit"
              :scale="1.1"
            ></zoom-on-hover>
          </div>
          <div class="panel-footer">{{ unit.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'Step4Unit',
  computed: {
    brand: {
      get() {
        return this.$store.state.brand;
      },
    },
    filteredUnits: {
      get() {
        return this.$store.state.availableFilteredUnits;
      },
    },
    filters: {
      get() {
        return this.$store.state.availableUnitsCategories;
      },
    },
    selectedFilter: {
      get() {
        return this.$store.state.selectedUnitCategory;
      },
    },
  },
  methods: {
    ...mapActions(['selectUnit', 'setFilteredUnits']),
  },
};
</script>
